export type StorageArea = 'local' | 'session';

const resolveArea = (area: StorageArea): Storage | undefined => {
  try {
    return area === 'local'
      ? globalThis.localStorage
      : globalThis.sessionStorage;
  } catch {
    return undefined;
  }
};

export const readItem = (area: StorageArea, key: string): string | null => {
  const storage = resolveArea(area);
  if (!storage) {
    return null;
  }
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
};

export const writeItem = (
  area: StorageArea,
  key: string,
  value: string,
): void => {
  const storage = resolveArea(area);
  if (!storage) {
    return;
  }
  try {
    storage.setItem(key, value);
  } catch {
    return;
  }
};

export const removeItem = (area: StorageArea, key: string): void => {
  const storage = resolveArea(area);
  if (!storage) {
    return;
  }
  try {
    storage.removeItem(key);
  } catch {
    return;
  }
};
